import { createIcon } from './icon-utils';

export const DownArrowIcon = createIcon({
  path: 'M12.308 14.37l6.866-6.557c.3-.286.775-.275 1.06.024.287.3.276.775-.024 1.06l-7.036 6.72c-.233.222-.544.346-.866.346-.323 0-.634-.124-.866-.346l-7.037-6.72c-.3-.285-.31-.76-.024-1.06.286-.3.76-.31 1.06-.024l6.867 6.557z',
});
